export const SCREEN_CONSTANTS = {
  height: 1440,
  width: 2560,
};
